// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader_sectionHeader__2bQOv"};